import React from "react";
// import { createContextualCan } from '@casl/react';
// 
const AppContext = React.createContext();

export default AppContext;
// export const Can = createContextualCan(AppContext.Consumer);

